<template>
  <b-sidebar
    id="sidebar-send-quote-distribution"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ $t('Send') }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="clear(hide)"
        />

      </div>

      <!-- Body -->
      <b-form
        class="p-2"
        enctype="multipart/form-data"
        @submit.prevent
      >
        <validation-observer ref="sendQuoteDistribution">

          <!-- Direction -->
          <b-form-group
            :label="$t('File')"
            label-for="direction"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('File')"
              rules="required|file-size:10"
            >
              <b-form-file
                v-model="file"
                :placeholder="$t('Choose a file or drop it here...')"
                accept="application/pdf"
                :drop-placeholder="$t('Drop file here...')"
                :state="errors.length > 0 ? false:null"
                @change="handleFile"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </validation-observer>
        <!-- Form Actions -->
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="success"
            class="mr-2"
            type="submit"
            @click="submit(hide)"
          >
            {{ $t('Send') }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="clear(hide)"
          >
            {{ $t('Cancel') }}
          </b-button>
        </div>
      </b-form>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BButton, BForm, BFormGroup, BSidebar, BFormFile,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required, fileSize } from '@/libs/validations/validations'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BButton,
    BFormFile,
    ValidationObserver,
    ValidationProvider,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      file: null,
      base64: null,
      required,
      fileSize,
    }
  },
  computed: {
    quoteDistribution() {
      return this.$store.state[this.MODULE_NAME].quoteDistribution
    },
  },
  created() {
    localize(this.$i18n.locale)
  },
  methods: {
    handleFile(e) {
      const selectedFile = e.target.files[0]
      this.base64 = selectedFile
    },
    clear(hide) {
      this.file = null
      this.$refs.sendQuoteDistribution.reset()
      hide()
    },
    submit(hide) {
      this.$refs.sendQuoteDistribution.validate().then(success => {
        if (success) {
          const params = new FormData()
          params.append('total_quote', this.quoteDistribution.id)
          params.append('file', this.base64)
          this.$confirmCode({
            callback: (confirm, code) => {
              if (confirm) {
                params.append('smsCode', code)
                this.$createSwal(this, params, `${this.MODULE_NAME}/send`, () => {
                  this.$emit('refetchData')
                })
                hide()
              }
            },
          })
        }
      })
    },
  },
  setup() {
    const MODULE_NAME = 'quoteDistribution'
    return {
      MODULE_NAME,
    }
  },
}
</script>
